<template>
  <card class="w-100">
    <el-form class="form-horizontal" :model="mediaInfo" :rules="rules" ref="company" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="매체구분" prop="mediaType">
            <el-select v-model="mediaInfo.mediaType">
              <el-option
                key="WC"
                value="WC"
                label="와이드칼라"></el-option>
              <el-option
                key="DM"
                value="DM"
                label="디지털미디어"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="매체명" prop="mediaName">
            <el-input v-model="mediaInfo.mediaName"></el-input>
          </el-form-item>
          <el-form-item label="넓이(mm)" prop="width">
            <el-input v-model="mediaInfo.width" @keyup.native="changeWidth"></el-input>
          </el-form-item>
          <el-form-item label="높이(mm)" prop="height">
            <el-input v-model="mediaInfo.height" @keyup.native="changeHeight"></el-input>
          </el-form-item>
          <el-form-item label="연광고료(원)" prop="prepaymentPrice">
            <el-input v-model="mediaInfo.prepaymentPrice" @keyup.native="changePrepaymentPrice"></el-input>
          </el-form-item>
          <el-form-item label="월광고료(원)" prop="installmentPrice">
            <el-input v-model="mediaInfo.installmentPrice" @keyup.native="changeInstallmentPrice"></el-input>
          </el-form-item>
          <el-form-item label="전체현황노출" prop="mainExposure">
            <el-switch v-model="mediaInfo.mainExposure"></el-switch>
          </el-form-item>
          <el-form-item label="조명여부" v-if="mediaInfo.mediaType === 'WC'" prop="isLight">
            <el-switch v-model="mediaInfo.isLight"></el-switch>
          </el-form-item>
          <el-form-item label="송출시간" v-if="mediaInfo.mediaType === 'DM'" prop="duration">
            <el-input type="number" v-model="mediaInfo.duration"></el-input>
          </el-form-item>
          <el-form-item label="IN/OUT" prop="inOut" v-if="false">
            <el-radio-group v-model="mediaInfo.inOut" size="small">
              <el-radio-button label="IN"></el-radio-button>
              <el-radio-button label="OUT"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="색상" prop="color">
            <div>
              <swatches style="line-height: normal" v-model="mediaInfo.color" colors="text-advanced"></swatches>
            </div>
          </el-form-item>
          <el-form-item label="정렬순서">
            <el-input type="number" v-model="mediaInfo.orderNum"></el-input>
          </el-form-item>
          <el-form-item label="상태" v-if="type === 'edit'">
            <el-select v-model="mediaInfo.status">
              <el-option
                label="정상"
                value="OK"></el-option>
              <el-option
                label="삭제"
                value="REMOVE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="card-footer text-right">
        <el-button type="primary" v-if="type === 'new'" @click="submitForm('company')">등록</el-button>
        <el-button type="primary" v-if="type === 'edit'" @click="submitForm('company')">수정</el-button>
        <el-button v-if="type === 'new'" @click.prevent="resetForm('company')">리셋</el-button>
        <el-button @click.prevent="historyBack">취소</el-button>
      </div>
    </el-form>
  </card>
</template>

<script>
    import Vue from 'vue'
    import {Select, DatePicker, Form, FormItem, Button, Option, Input, Row, Col, Table, TableColumn, Switch, RadioButton, RadioGroup} from 'element-ui';
    import MediaInfoProxy from "../../../../proxies/MediaInfoProxy";
    import Swatches from 'vue-swatches'

    import "vue-swatches/dist/vue-swatches.min.css"

    Vue.use(Table);
    Vue.use(TableColumn);

    export default {
        name: "SettingsAccountRegistration",
        components: {
            [DatePicker.name]: DatePicker,
            elSelect: Select,
            elForm: Form,
            elFormItem: FormItem,
            elButton: Button,
            elOption: Option,
            elInput: Input,
            elRow: Row,
            elCol: Col,
            elSwitch: Switch,
            elRadioButton: RadioButton,
            elRadioGroup: RadioGroup,
            Swatches,
        },
        created: function () {
            if(this.$route.params.mediaInfoSeq !== undefined) {
                this.type = "edit";
                this.mediaInfo.mediaInfoSeq = this.$route.params.mediaInfoSeq;
                this.searchName = this.$route.params.searchName;
                this.searchMediaType = this.$route.params.searchMediaType;
                this.$store.dispatch('common/setMenuTitle', "매체수정");
                new MediaInfoProxy()
                    .find(this.mediaInfo.mediaInfoSeq)
                    .then((response) => {
                        this.mediaInfo = response.mediaInfo;
                        this.mediaInfo.width = this.numberWithCommas(response.mediaInfo.width.toString());
                        this.mediaInfo.height = this.numberWithCommas(response.mediaInfo.height.toString());
                        this.mediaInfo.prepaymentPrice = this.numberWithCommas(response.mediaInfo.prepaymentPrice.toString());
                        this.mediaInfo.installmentPrice = this.numberWithCommas(response.mediaInfo.installmentPrice.toString());
                    })
            } else {
                this.type = "new";
                this.$store.dispatch('common/setMenuTitle', "매체등록");
            }
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.mediaInfo.mediaType === "WC") {
                            this.mediaInfo.duration = 0;
                        }
                        if(this.type === "new") {
                            if(confirm("등록하시겠습니까?")) {
                                this.mediaInfo.status = "OK";
                                this.mediaInfo.width = Vue.FilterNumber(this.mediaInfo.width);
                                this.mediaInfo.height = Vue.FilterNumber(this.mediaInfo.height);
                                this.mediaInfo.prepaymentPrice = Vue.FilterNumber(this.mediaInfo.prepaymentPrice);
                                this.mediaInfo.installmentPrice = Vue.FilterNumber(this.mediaInfo.installmentPrice);
                                this.$store.dispatch("media/createMediaInfo", this.mediaInfo);
                            }
                        } else {
                            if(confirm("수정하시겠습니까?")) {
                                this.mediaInfo.regDate = null;
                                this.mediaInfo.searchName = this.searchName;
                                this.mediaInfo.searchMediaType = this.searchMediaType;
                                this.mediaInfo.width = Vue.FilterNumber(this.mediaInfo.width);
                                this.mediaInfo.height = Vue.FilterNumber(this.mediaInfo.height);
                                this.mediaInfo.prepaymentPrice = Vue.FilterNumber(this.mediaInfo.prepaymentPrice);
                                this.mediaInfo.installmentPrice = Vue.FilterNumber(this.mediaInfo.installmentPrice);
                                this.$store.dispatch("media/editMediaInfo", this.mediaInfo);
                            }
                        }
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            historyBack() {
              Vue.router.push({
                name: 'MediaManagement',
                params: {searchName: this.searchName, searchMediaType: this.searchMediaType}
              });
            },
            numberWithCommas(x) {
                return Vue.NumberWithCommas(x);
            },
            changeWidth(event) {
                this.mediaInfo.width = this.numberWithCommas(this.mediaInfo.width);
            },
            changeHeight(event) {
                this.mediaInfo.height = this.numberWithCommas(this.mediaInfo.height);
            },
            changePrepaymentPrice(event) {
                this.mediaInfo.prepaymentPrice = this.numberWithCommas(this.mediaInfo.prepaymentPrice);
            },
            changeInstallmentPrice(event) {
                this.mediaInfo.installmentPrice = this.numberWithCommas(this.mediaInfo.installmentPrice);
            }
        },
        data() {
            let checkInOut = (rule, value, callback) => {
                if(this.mediaInfo.inOut === '') {
                    callback(new Error('IN/OUT을 선택하세요.'));
                } else {
                    callback();
                }
            };
            return {
                searchName: '',
                searchMediaType: "",
                type: '',
                mediaInfo: {
                    mediaType: '',
                    mediaName: '',
                    prepaymentPrice: '',
                    installmentPrice: '',
                    width: '',
                    height: '',
                    isLight: false,
                    packaged: false,
                    status: '',
                    inOut: '',
                    duration: '',
                    color: '#131fd5',
                    mainExposure: true,
                    orderNum: 0,
                    searchName: '',
                    searchMediaType: "",
                },
                rules: {
                    mediaType: [
                        { required: true, message: '매체구분을 선택하세요.', trigger: 'change' }
                    ],
                    mediaName: [
                        { required: true, message: '매체명을 입력하세요.', trigger: 'blur' }
                    ],
                    width: [
                        { required: true, message: '넓이을 입력하세요.', trigger: 'blur' }
                    ],
                    height: [
                        { required: true, message: '높이를 입력하세요.', trigger: 'blur' }
                    ],
                    prepaymentPrice: [
                        { required: true, message: '연광고료를 입력하세요.', trigger: 'blur' }
                    ],
                    installmentPrice: [
                        { required: true, message: '월광고료를 입력하세요.', trigger: 'blur' }
                    ],
                    duration: [
                        { required: true, message: '송출시간을 입력하세요.', trigger: 'blur' }
                    ],
                    inOut: [
                        { required: true, validator: checkInOut, trigger: 'change' }
                    ],
                }
            }
        },

    }
</script>

<style scoped>

</style>
